import React, { useState, useEffect } from "react";
import "./Testimonials.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import img from "../Assets/Images/UnknownUser1024.webp";

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          "https://api.dremerz.net/api/DZ_8921_smcproject_feedbacktable_feedbacklist"
        );
        const data = await response.json();
        if (data && Array.isArray(data)) {
          setTestimonials(data);
        }
      } catch (err) {
        console.error("Error fetching testimonials:", err);
      }
    };
    fetchData();
  }, []);

  function Arrow(props) {
    const { className, style, onClick, direction } = props;
    return (
      <div
        className={`${className} custom-arrow ${direction}`}
        style={{ ...style }}
        onClick={onClick}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="25"
          viewBox="0 0 14 25"
          fill="none"
        >
          <path
            d={
              direction === "prev"
                ? "M13 1.5L2 12.5L13 23.5"
                : "M1 1.5L12 12.5L1 23.5"
            }
            stroke="#58038A"
            strokeWidth="1.63"
            strokeLinecap="round"
          />
        </svg>
      </div>
    );
  }

  const settings = {
    prevArrow: <Arrow direction="prev" />,
    nextArrow: <Arrow direction="next" />,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="testimonials-section">
      <h2 className="section-title">What Our Clients Say's</h2>
      <p className="section-subtitle">Hear from our satisfied customers</p>
      <div className="slider-container">
        <Slider {...settings}>
          {testimonials.map((item) => (
            <div className="testimonial-card" key={item.id}>
              <img src={img} alt="User" className="testimonial-image" />
              <div className="testimonial-content">
                <h5 className="testimonial-name">{item.name}</h5>
                <p className="testimonial-text">"{item.description}"</p>
              </div>
              <div className="testimonial-footer">
                <span className="testimonial-date">
                  {new Date(item.currentDate).toLocaleDateString()}
                </span>
                <span className="testimonial-time">{item.currentTime}</span>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Testimonials;
